import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";
import { getBrandInfoFromVnAppZone } from "./BrandHelper";
import { PermissionCheck, permissionCheckStyle, permission_detail } from "./types/permission";

export const userCanEditOwnedTagType = (
    vnAppZone: vnAppZone,
    permissions: Array<permission_detail>,
    idBrand: number,
    idBrandOwner: number,
) => {
    // nobody owns it, or the idBrand handles the UI otherwise for selecting default values.
    if (!idBrandOwner || idBrand) {
        return true;
    } else {
        // must have one of the permissions
        const permChecks = [
            new PermissionCheck('tag_type_edit_owned', 'write'),
            new PermissionCheck('tag_type_edit_owned', 'update'),
        ];
        // owned tag type, do you have access to it?
        // get the brand by the id from the user's data
        return userHasPermissions(permissions, permChecks, 'some') && getBrandInfoFromVnAppZone(vnAppZone, idBrandOwner) !== null;
    }
}

/**
 * Check if a permissions array has a specific section/detail combination
 *
 * @param permissions
 * @param section
 * @param detail
 * @returns boolean
 */
export const userHasPermission = (
    permissions: Array<permission_detail>,
    section: string,
    detail: string
): boolean => {
    return userHasPermissions(permissions, [new PermissionCheck(section, detail)], 'all');
}

/**
 * Check if a permissions array has all or at least one of the section/detail combinations being sought.
 *
 * @param permissions
 * @param checks an array of PermissionCheck objects to identify the permission we're seeking.
 * @param style 'all' or 'none'. Must have
 */
export const userHasPermissions = (
    permissions: Array<permission_detail>,
    checks: Array<PermissionCheck>,
    style: permissionCheckStyle,
) => {
    const results = checks.filter((detail) => {
        return !!permissions[detail.section] && !!permissions[detail.section][detail.detail];
    });

    return style === 'all' ? results.length === checks.length : results.length > 0;
}



// WEBPACK FOOTER //
// ./js/utils/PermissionsHelper.ts